/*
 * Configuration for Microsoft Authentication Library (MSAL)
 */

import { LogLevel } from "@azure/msal-browser";

/**
 * Get appropriate redirect URI based on environment
 * Supports both local development and production deployments
 */
const getRedirectUri = () => {
    // For local development with direct access to React dev server
    if (window.location.hostname === 'localhost' && window.location.port === '3000') {
        return 'http://localhost:3000';
    }
    
    // For SWA CLI emulator (typically runs on port 4280)
    if (window.location.hostname === 'localhost' && window.location.port === '4280') {
        return 'http://localhost:4280';
    }
    
    // For production or other environments, use the dynamic origin
    return window.location.origin;
};
/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig = {
    auth: {
        clientId: "ee3a598e-30a4-42fc-b89d-8ec46ca2d3df", // Hardcoded client ID
        //authority: "https://login.microsoftonline.com/common/", // Using 'consumers' tenant for personal Microsoft accounts
        authority: "https://login.microsoftonline.com/263f52e7-8d6d-4cd5-a331-1d1965c0b44a",
        redirectUri: getRedirectUri(), // Dynamically determine the appropriate redirect URI
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {	
        loggerOptions: {	
            loggerCallback: (level, message, containsPii) => {	
                if (containsPii) {		
                    return;		
                }		
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }	
            }	
        }	
    }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 */
export const loginRequest = {
    scopes: ["User.Read"]
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API.
 */
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};